import { FolderOpenOutlined } from "@ant-design/icons";
import { Table } from "antd";

export const CustomTable = ({
  columns,
  loading,
  dataSource,
  onShowSizeChange,
  pageSize,
  page,
  onChange,
  emptyText = "Veri Bulunamadı.",
  count,
  size = "middle",
  rowClassName,
}) => {
  return (
    <Table
      columns={columns}
      size={size}
      rowKey={(record) => {
        if (typeof record === "object" && "id" in record) {
          return record.id;
        }
        return Math.random().toString();
      }}
      loading={loading}
      scroll={{ x: 500 }}
      dataSource={dataSource}
      rowClassName={rowClassName}
      locale={{
        emptyText: (
          <div className="flex items-center gap-2 mx-auto w-full h-[60vh] text-[18px]">
            <label className="flex items-center gap-2 mx-auto">
              <FolderOpenOutlined className="text-[24px]" />
              {emptyText}
            </label>
          </div>
        ),
      }}
      pagination={
        pageSize === 0
          ? undefined
          : {
              pageSize: pageSize,
              current: page + 1,
              total: count,
              showSizeChanger: true,
              onShowSizeChange: (page, pageSize) => {
                onShowSizeChange(page - 1, pageSize);
              },
              showTotal: (total, range) => `${total} kayıt bulundu.`,
              onChange: (page, pageSize) => {
                onChange(page - 1, pageSize);
                window.scrollTo({ top: 0, behavior: "smooth" });
              },
            }
      }
    />
  );
};
